import { useMutation } from "@tanstack/react-query"
import { useCallback } from "react"
import { startSamlAuthFetch } from "store/middlewares/auth.crud"

const useSamlAuth = () => {
    const { mutateAsync: startSamlAuth, isPending, error } = useMutation({
        mutationFn: startSamlAuthFetch,
        onSuccess: async (res) => {
            const { data } = res
            console.log("SAML redirect URL received:", data.redirect_url)
            
            if (data.success && data.redirect_url) {
                // Redirect to the IDP login page
                window.location.href = data.redirect_url;
            } else {
                console.error("Failed to get SAML redirect URL:", data.error);
            }
        },
        onError: (error) => {
            console.error("SAML authentication error:", error);
        }
    })

    const startAuth = useCallback(() => {
        console.log("Starting SAML authentication...");
        startSamlAuth()
    }, [startSamlAuth])

    return { startAuth, isPending, error }
}

export default useSamlAuth